import _pt from "prop-types";
var _excluded = ["id", "children", "className", "base", "sm", "md", "lg", "xl"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import React from 'react';
import classNames from 'classnames';
import "./gridCol.css";
var getClassNames = function getClassNames(breakpoints) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var classes = ['lm-Col', className];
  var modifiedBreakpoints = breakpoints;
  Object.keys(breakpoints).forEach(function (point) {
    if (breakpoints[point] !== undefined) {
      classes.push(breakpoints[point] === 0 ? "lm-Col--".concat(point, "-hide") : "lm-Col--".concat(point, "-").concat(breakpoints[point]));
    } else {
      delete modifiedBreakpoints[point];
    }
  });
  if (Object.keys(modifiedBreakpoints).length > 0 && !modifiedBreakpoints.base) {
    classes.push('lm-Col--base-12');
  }
  return classNames.apply(void 0, classes);
};

/**
 * @see [LMDS GridCol documentation and examples](https://designsystem.lmig.com/components/grids/code)
 *
 * API:
 * @implements [GridColProps](https://designsystem.lmig.com/components/grids/code#grid-col-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var GridCol = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    base = _ref.base,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    xl = _ref.xl,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: getClassNames({
      base: base,
      sm: sm,
      md: md,
      lg: lg,
      xl: xl
    }, className),
    ref: ref
  }, otherProps), children);
});
GridCol.propTypes = {
  /** Add an optional ID to this element: `<div class="lm-Col">`. */id: _pt.string,
  /** Add custom classes to this element: `<div class="lm-Col">`. */className: _pt.string,
  /** The 'base' breakpoint starts at 0px width.
     * If no other breakpoint configurations are specified, this configuration will apply to all larger window widths.
     * A flex property OR a numeric column count can be supplied. */
  base: _pt.oneOf(['flex-auto', 'flex-initial', 'flex-none', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /** If no larger breakpoint configurations are specified, this configuration will apply to all larger window widths.
     * A flex property OR a numeric column count can be supplied. */
  sm: _pt.oneOf(['flex-auto', 'flex-initial', 'flex-none', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /** If no larger breakpoint configurations are specified, this configuration will apply to all larger window widths.
     * A flex property OR a numeric column count can be supplied. */
  md: _pt.oneOf(['flex-auto', 'flex-initial', 'flex-none', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /** If a larger breakpoint configuration is not specified, this configuration will apply to all larger window widths.
     * A flex property OR a numeric column count can be supplied. */
  lg: _pt.oneOf(['flex-auto', 'flex-initial', 'flex-none', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /** This configuration will apply to anything above the extra-large breakpoint.
     * A flex property OR a numeric column count can be supplied. */
  xl: _pt.oneOf(['flex-auto', 'flex-initial', 'flex-none', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /** The contents of the grid cell. Children rendered inside `<div class="lm-Col">`. */children: _pt.node
};
GridCol.displayName = 'GridCol';